import React  from "react";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import "./RefuseModal.css";
import Coruja from "../../../../images/owl-refuse-proposal.svg"
import CustomSpinner from "../../../CustomSpinner";

const RefuseModal = (props) => {

    const {
        handleClose,
        openModal,
        action,
        loading
    } = props;


    return (
        <Modal
            open={openModal}
            onClose={handleClose}
            disableAutoFocus
        >
            <div className="modal-refuse-proposal">
              {/* <CloseIcon /> */}
              <h2>Recusar proposta do advogado!</h2>
              <div><img src={Coruja} alt="Bonuz owl"/></div>
              <p>Tem certeza que gostaria de recusar proposta?</p>
              <Box className="modal-refuse-proposal-buttons-container">
                <Button onClick={handleClose} className="modal-refuse-proposal-reject-button">
                  Cancelar
                </Button>
                <Button onClick={action} className="modal-refuse-proposal-refuse-button">
                  {loading ? <CustomSpinner /> : 'Sim'}
                </Button>
              </Box>
            </div>
        </Modal>

    );
};

export default RefuseModal;